import React from 'react';

export const MOBILE_WIDTH = 850;

export default (): boolean => {
  const [isMobile] = React.useState(window.innerWidth <= MOBILE_WIDTH);

  return isMobile;
};
